module.exports = __webpack_public_path__ + "img/social_standards_circle_logo.8542f015.png";